export const DRAWER_CARD_LAYOUTS = {
  overlay: {
    position: 'absolute',
    width: 'full',
    height: 'full',
  },
} as const

export const DRAWER_CARD_MIN_HEIGHTS = {
  compact: '76px',
} as const

export type DrawerCardLayout = keyof typeof DRAWER_CARD_LAYOUTS
export type DrawerCardMinHeightSize = keyof typeof DRAWER_CARD_MIN_HEIGHTS

export const DrawerCardLayoutUtils = {
  layout: (layout?: DrawerCardLayout) =>
    layout ? DRAWER_CARD_LAYOUTS[layout] : {},
  minHeight: (size?: DrawerCardMinHeightSize) =>
    size ? { minHeight: DRAWER_CARD_MIN_HEIGHTS[size] } : {},
} as const
